import { topicStats } from '@/mocks/blackMaterial';
import Reveal from './Reveal';
import SectionHeading from './SectionHeading';

const TRENDING = [
  { rank: 1, title: '直播「原厂货」质检比对全集', tag: '实锤', tagInk: false, hot: 982, replies: 1240, up: 12 },
  { rank: 2, title: '综艺剧本内定：成团路径逐帧复盘', tag: '跟进中', tagInk: true, hot: 861, replies: 987, up: 9 },
  { rank: 3, title: '饭圈大额集资晒账疑云追踪', tag: '实锤', tagInk: false, hot: 744, replies: 765, up: 7 },
  { rank: 4, title: 'MCN 解约条款「霸王模板」调查', tag: '跟进中', tagInk: true, hot: 629, replies: 543, up: 5 },
  { rank: 5, title: '网红富二代人设前后口径比对', tag: '实锤', tagInk: false, hot: 517, replies: 421, up: 3 },
];

export default function TrendingSection() {
  return (
    <section id="tuolu" className="scroll-mt-28 border-y border-[#e0d6c6] bg-[#efe7d7]/70">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-16">
        <div className="grid gap-8 lg:grid-cols-12">
          {/* 数据条 + 排行 */}
          <div className="lg:col-span-8">
            <Reveal>
              <SectionHeading
                kicker="HOT · 围观热度"
                title="进行中讨论 · 热度排行"
                desc="围观不是终点，证据才是。热度越高的专题，代表越多人正在交叉比对信源。"
              />
            </Reveal>

            <Reveal delay={80}>
              <ol className="space-y-2">
                {TRENDING.map((t) => (
                  <li key={t.rank}>
                    <div className="group flex items-center gap-3 rounded-lg bg-white px-3 py-3 ring-1 ring-[#e6dbc9] transition hover:ring-[#c83424] md:px-4">
                      <span
                        className={`font-display w-8 shrink-0 text-center text-xl font-black ${
                          t.rank <= 3 ? 'text-[#c83424]' : 'text-[#c9bdab]'
                        }`}
                      >
                        {t.rank}
                      </span>
                      <div className="min-w-0 flex-1">
                        <p className="truncate text-sm font-semibold text-[#332c24] group-hover:text-[#b0392a] md:text-[15px]">
                          {t.title}
                        </p>
                        <p className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] text-[#9a8a75]">
                          <span
                            className={`rounded px-1.5 py-0.5 font-semibold ${
                              t.tagInk ? 'bg-[#fbf3e0] text-[#9a6b13]' : 'bg-[#fdeee9] text-[#b0392a]'
                            }`}
                          >
                            {t.tag}
                          </span>
                          <span className="flex items-center gap-1">
                            <i className="ri-chat-3-line"></i>{t.replies} 讨论
                          </span>
                          <span className="flex items-center gap-1">
                            <i className="ri-arrow-up-line text-[#c83424]"></i>日涨 {t.up}%
                          </span>
                        </p>
                      </div>
                      <span className="hidden shrink-0 items-center gap-1 text-sm font-bold text-[#b0392a] sm:flex">
                        <i className="ri-fire-fill text-[#e8603c]"></i>{t.hot}
                      </span>
                    </div>
                  </li>
                ))}
              </ol>
            </Reveal>
          </div>

          {/* 数据总览 */}
          <div className="lg:col-span-4">
            <Reveal delay={120}>
              <div className="grid h-full content-start gap-4 lg:sticky lg:top-32">
                <div className="rounded-lg bg-[#262019] p-5 text-[#f5efe3]">
                  <p className="flex items-center gap-2 text-xs font-bold tracking-[0.25em] text-[#e0a01a]">
                    <i className="ri-bar-chart-box-line"></i>实时数据看板
                  </p>
                  <div className="mt-5 grid grid-cols-2 gap-4">
                    {topicStats.map((s) => (
                      <div key={s.id} className="rounded-md bg-[#322a22]/70 p-3">
                        <p className="font-display text-2xl font-black text-white">{s.value.toLocaleString()}</p>
                        <p className="mt-1 text-[11px] text-[#c9bdab]">{s.label}</p>
                        <p className="mt-1.5 flex items-center gap-1 text-[11px] font-semibold text-[#e0a01a]">
                          <i className="ri-arrow-up-line"></i>较昨日 +{s.trend}
                        </p>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="rounded-lg border border-dashed border-[#d0c2aa] bg-[#f6f1e8] p-4 text-xs leading-6 text-[#6b5f51]">
                  <p className="flex items-center gap-1.5 font-bold text-[#262019]">
                    <i className="ri-information-line text-[#c83424]"></i>阅读提示
                  </p>
                  热度与讨论数仅反映站内围观趋势，不代表结论成立。每条结论都以「证据编号 + 复核状态」为准，可点进专题自查原始材料。
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}